import React, { useState } from 'react';
import stylesCommon from "../../common.module.scss"
import CustomLists from '../../../custom/custom-lists/CustomLists';
import CustomButton from '../../../custom/custom-button/CustomButton';
import { useRegistration } from '../../../../hooks/useRegistration';
import { t } from "i18next";

export const USER_TYPE = {
  CLIENT: "client",
  EXPEDITOR: "expeditor",
};

const SurveyUserRegistrationSecond = ({ updateStep, setData, data, code, clientId }) => {
  const { isLoading, performRegistration } = useRegistration();
  const [isCheck, setIsCheck] = useState((data.type === USER_TYPE.CLIENT || data.type === USER_TYPE.EXPEDITOR) ? true : false);

  const items = [
    {
      text: t('registrationSurveyUserSecond.orgType.shipper'),
      summary: t('registrationSurveyUserSecond.orgType.shipperSummary'),
      value: USER_TYPE.CLIENT,
    },
    {
      text: t('registrationSurveyUserSecond.orgType.transporter'),
      summary: t('registrationSurveyUserSecond.orgType.transporterSummary'),
      value: USER_TYPE.EXPEDITOR,
    }
  ];

  const activeChoiceIndex = data?.type === USER_TYPE.CLIENT ? 0 : (data?.type === USER_TYPE.EXPEDITOR ? 1 : null);

  const handleUserRoleChange = (selectedIndex) => {
    const selectedValue = items[selectedIndex].value;
    setData({ ...data, type: selectedValue, isHead: true });
    setIsCheck(true);
  };

  const nextStep = async () => {
    if (isCheck) {
      try {
        await performRegistration(data, code, clientId);
      } catch (error) {
        // Error already handled in hook
      }
    }
  };

  return (
    <div className={stylesCommon.fullWidth}>
      <CustomLists
        items={items}
        isRadioBtn={true}
        onSelectionChange={handleUserRoleChange}
        activeChoice={activeChoiceIndex}
      />
      <div className={stylesCommon.mrXmedium}>
        <CustomButton isFall isLoading={isLoading} isDisabled={!isCheck} text={t('registrationSurveyUserSecond.button.login')} onClick={nextStep} />
      </div>
    </div>
  );
};

export default SurveyUserRegistrationSecond;